export default "/assets/images/mila-valentine-mobile-b-w.png?621a701b9ec82b18a94d73c024b5f390";